// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e057676f","239":"3877ba59","455":"4c358d46","557":"96e4bc83","762":"b38c7163"}[chunkId] + ".chunk.js";
};